/* @flow */

import type {AccountInput} from 'shells/peep-cards/account-card';

export function accountInputToDisplayOptionEntity(
    input: AccountInput,
    isNew: boolean,
    id?: string
) {
    const result = {
        value: input.name,
        description: input.description,
        tertiaryInfo: input.address,
        isNew: isNew,
        ...(id ? {id} : {}), // This is necessary to satisfy flow and allow for id to be optional
    };

    return result;
}
